import KOD_EXT_1 from "./KOD_EXT_1";
export default {
  KOD_EXT_1,
};
